module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path == '/SendGoods/SendGoodsForHXView') ? _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "70%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderCode))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.IsViewPrint),
      expression: "Form.IsViewPrint"
    }],
    staticStyle: {
      "margin-left": "350px"
    },
    on: {
      "click": _vm.printSendGooods
    }
  }, [_vm._v("打印发货通知单")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentCode) + "   " + _vm._s(_vm.Form.AgentName) + "   " + _vm._s(_vm.Form.AgentAddress) + "   " + _vm._s(_vm.Form.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "下单对象"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.ObjectName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendTime))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单下单人"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AddUserName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货情况"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.DeliveryStatusName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ProjectType == 2),
      expression: "Form.ProjectType==2"
    }]
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "Hi幼教样机数量"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.ProtoTypeNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "样机已抵扣数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.ProtoTypeDeductibleNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "此单需抵扣数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderProtoTypeDeductibleNum))])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.PackageName != ''),
      expression: "Form.PackageName!=''"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PackageName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.AgentOutNum > 0),
      expression: "Form.AgentOutNum >0"
    }],
    attrs: {
      "label": "经销商库存发货情况"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "data": _vm.Form.AgentOutList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "使用库存",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "AgentName",
      "label": "代理商名字",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "C_Name",
      "label": "主联系人",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "使用数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.Form.AgentOutNum) + "\n                        ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ListGoods != ''),
      expression: "Form.ListGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "data": _vm.Form.ListGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含单品",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PackDetail.length == 0) ? _c('div', [_vm._v("--")]) : _c('div', {
          staticClass: "dpDvCtnCss"
        }, _vm._l((scope.row.PackDetail), function(PackDetail) {
          return _c('div', {
            staticClass: "dpDvCss"
          }, [_vm._v(_vm._s(PackDetail.ProName))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "通知数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.GiftGoods != ''),
      expression: "Form.GiftGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "赠品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "data": _vm.Form.GiftGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含单品",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PackDetail.length == 0) ? _c('div', [_vm._v("--")]) : _c('div', {
          staticClass: "dpDvCtnCss"
        }, _vm._l((scope.row.PackDetail), function(PackDetail) {
          return _c('div', {
            staticClass: "dpDvCss"
          }, [_vm._v(_vm._s(PackDetail.ProName))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "通知数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ApplyPic.length > 0),
      expression: "Form.ApplyPic.length>0"
    }],
    attrs: {
      "label": "租用申请表"
    }
  }, [_c('div', {
    staticClass: "show-img-ctn uclear"
  }, [_vm._l((_vm.Form.ApplyPic), function(item, index) {
    return [_c('div', {
      staticClass: "show-img-cell",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": item.Name,
        "src": item.Url
      }
    })])]
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentConsignee))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.Consignee) + "--" + _vm._s(_vm.Form.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "订单备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderRemark))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "财务审核备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AuditRemark))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "寄送方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PayModeName))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.viewSure
    }
  }, [_vm._v("我知道了")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.PictureVisible),
      callback: function($$v) {
        _vm.PictureVisible = $$v
      },
      expression: "PictureVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)], 1) : _c('div', [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e5cdb61!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SendGoods/SendGoodsForHXView.vue
// module id = 1499
// module chunks = 1